import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditopuneairportcab() {



    const cardData = {





keyword: "Shirdi to Pune Airport Cab",
headingDescription: "Sai Shirdi Cab provides convenient Shirdi to Pune Airport cab service for passengers traveling from Shirdi to Pune International Airport for domestic and international flights. The service is suitable for families, business travelers, tourists, devotees, students, and small groups who need a dependable airport transfer from Shirdi. Customers can book a one-way cab according to their flight schedule or choose a round-trip arrangement when required. Sai Shirdi Cab focuses on timely pickup, comfortable vehicles, experienced drivers, luggage-friendly travel, and direct transportation to Pune Airport without unnecessary changes. The cab can be scheduled for early-morning departures, daytime flights, evening travel, and late-night airport transfers, making it easier to coordinate the journey with the passenger's flight timing. For travelers planning an extended Maharashtra trip, the service can also be combined with outstation destinations and customized travel routes.",

topPlaces: [
{
title: "Bhimashankar",
description: "Bhimashankar is a suitable pilgrimage destination for travelers planning to combine their Shirdi journey with a visit to an important religious site before continuing toward Pune. Sai Shirdi Cab can arrange a customized private cab itinerary covering Shirdi, Bhimashankar, and Pune Airport according to the flight schedule. This option is useful for families and devotees who want planned transportation with sufficient time for sightseeing and airport travel."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar can be included in an extended Maharashtra travel itinerary for passengers combining a Shirdi visit with a leisure trip before flying from Pune Airport. Sai Shirdi Cab can arrange private outstation transportation with planned stops and airport drop arrangements. Travelers can coordinate the sightseeing schedule and departure time around their flight requirements for a smoother journey."
},
{
title: "Nashik",
description: "Nashik is a practical destination to include in a wider Shirdi travel plan for passengers interested in pilgrimage, temples, and sightseeing before continuing toward Pune. Sai Shirdi Cab can organize a customized cab route covering Shirdi, Nashik, and Pune Airport. The itinerary can be planned as a multi-stop journey with convenient pickup, sightseeing time, luggage handling, and airport transfer."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is an important religious destination that can be added to a Maharashtra pilgrimage itinerary involving Shirdi and Pune Airport. Sai Shirdi Cab offers private cab arrangements for travelers who want to cover multiple destinations before their flight. The route can be customized around temple visits and airport reporting time to help passengers maintain a well-planned travel schedule."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur can be included in a pilgrimage itinerary for passengers traveling from Shirdi toward Pune Airport. Families and devotees can book a private cab through Sai Shirdi Cab to combine religious visits with their airport transfer. The journey can be arranged with planned pickup and drop timings, making it easier to complete the pilgrimage and reach Pune Airport according to the flight schedule."
},
{
title: "Bhandardara",
description: "Bhandardara offers a scenic nature destination for travelers extending their Shirdi trip before traveling onward to Pune Airport. Sai Shirdi Cab can arrange private transportation for families and small groups who want to include sightseeing in their Maharashtra itinerary. The cab journey can be customized with planned stops and a suitable departure schedule based on the passenger's airport reporting time."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta-Ellora Caves are an excellent heritage option for travelers planning a longer Maharashtra tour around their Shirdi visit. Sai Shirdi Cab can organize private cab transportation for passengers who want to cover historical attractions before continuing toward Pune Airport. A customized itinerary allows travelers to manage sightseeing, luggage, overnight stays, and airport drop requirements according to their flight plans."
},
{
title: "Goa",
description: "Goa can be considered for travelers planning an extended holiday itinerary that includes Shirdi and onward travel through Pune Airport. Sai Shirdi Cab can arrange private outstation transportation for families and small groups requiring flexible intercity travel. Depending on the complete itinerary, the cab journey can be organized around sightseeing, hotel stays, luggage requirements, and the final airport transfer."
},
{
title: "Saputara",
description: "Saputara is a suitable leisure destination for travelers combining a Shirdi pilgrimage with a longer hill-station holiday before continuing toward Pune. Sai Shirdi Cab can arrange customized private cab travel with planned sightseeing and intercity transfers. Passengers can coordinate their travel schedule around their Pune Airport flight to make the overall journey more organized and convenient."
},
{
title: "Aurangabad",
description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a useful heritage and sightseeing destination to combine with a Shirdi travel itinerary. Sai Shirdi Cab can provide private cab transportation for travelers visiting historical attractions before continuing toward Pune Airport. The journey can be arranged as a customized multi-stop route with airport drop timing planned according to the passenger's flight schedule."
}
]
,








"services": [
{
"name": "Shirdi to Pune Airport Cab",
"description": "Shirdi to Pune Airport Cab provides convenient private transportation for travelers going from Shirdi to Pune Airport. The service is suitable for families, devotees, business travelers, and groups, with vehicle options based on passenger count, luggage, pickup location, and flight schedule."
},
{
"name": "Shirdi to Pune Airport Taxi",
"description": "Shirdi to Pune Airport Taxi offers comfortable point-to-point transportation for passengers traveling from Shirdi to Pune Airport. Travelers can arrange a suitable cab according to their preferred departure time, luggage requirements, passenger count, and airport travel needs."
},
{
"name": "Shirdi to Pune Airport cab service",
"description": "Shirdi to Pune Airport cab service provides a practical option for passengers who need private airport transportation from Shirdi. The journey can be planned around flight timings with suitable pickup arrangements and vehicle choices for individuals, families, and groups."
},
{
"name": "Shirdi to Pune Airport taxi service",
"description": "Shirdi to Pune Airport taxi service helps travelers arrange direct transportation for their airport journey. Customers can choose a suitable vehicle and coordinate pickup timing according to their flight schedule, passenger requirements, luggage, and destination."
},
{
"name": "Shirdi to Pune Airport cab booking",
"description": "Shirdi to Pune Airport cab booking allows passengers to arrange their airport transfer in advance for a scheduled flight. Customers can provide the pickup location, travel date, flight timing, passenger count, luggage details, and preferred vehicle type."
},
{
"name": "Shirdi to Pune Airport taxi booking",
"description": "Shirdi to Pune Airport taxi booking makes it convenient to reserve private transportation before traveling to the airport. It is suitable for families, devotees, corporate travelers, and groups who require a planned pickup from Shirdi."
},
{
"name": "Shirdi to Pune Airport taxi fare",
"description": "Shirdi to Pune Airport taxi fare may vary according to the selected vehicle, travel schedule, journey type, and additional requirements. Travelers can choose a suitable taxi based on their passenger count, luggage needs, and preferred airport transfer arrangement."
},
{
"name": "Shirdi to Pune Airport cab fare",
"description": "Shirdi to Pune Airport cab fare depends on factors such as vehicle category, travel requirements, pickup location, and journey type. Customers can discuss their complete airport transfer plan and select an appropriate cab according to their requirements."
},
{
"name": "Shirdi to Pune Airport one way cab",
"description": "Shirdi to Pune Airport one way cab is ideal for passengers who need direct transportation from Shirdi to Pune Airport without requiring a return vehicle. The trip can be scheduled according to the flight departure time, pickup point, luggage, and passenger requirements."
},
{
"name": "Shirdi to Pune Airport one way taxi",
"description": "Shirdi to Pune Airport one way taxi provides private point-to-point transportation for travelers heading to Pune Airport. It is suitable for individuals, families, and groups looking for a convenient airport transfer based on their planned flight schedule."
},
{
"name": "Shirdi to Pune Airport round trip cab",
"description": "Shirdi to Pune Airport round trip cab is suitable for travelers who need transportation for both their airport journey and return travel. The arrangement can be planned around flight schedules, return dates, passenger requirements, and preferred vehicle type."
},
{
"name": "Shirdi to Pune Airport Ertiga Cab",
"description": "Shirdi to Pune Airport Ertiga Cab is a suitable option for families and small groups requiring additional seating and luggage space. The vehicle can be arranged for airport transfers according to the passenger count, travel date, pickup location, and flight timing."
},
{
"name": "Shirdi to Pune Airport Innova Cab",
"description": "Shirdi to Pune Airport Innova Cab offers a spacious private travel option for families and groups heading to Pune Airport. It can be booked for scheduled airport transfers with suitable arrangements for passengers, luggage, pickup timing, and travel requirements."
},
{
"name": "Shirdi to Pune Airport Innova Crysta Cab",
"description": "Shirdi to Pune Airport Innova Crysta Cab is suitable for travelers looking for a premium and spacious vehicle for their airport transfer. It provides a practical option for families, corporate travelers, and groups carrying luggage for their flight."
},
{
"name": "Shirdi to Pune Airport Sedan Cab",
"description": "Shirdi to Pune Airport Sedan Cab provides a convenient transportation option for individuals, couples, and small families traveling to Pune Airport. The sedan can be arranged for direct airport transfers according to the preferred pickup time and flight schedule."
},
{
"name": "Shirdi Airport to Pune Cab",
"description": "Shirdi Airport to Pune Cab provides private transportation for passengers traveling from the Shirdi Airport area toward Pune. It can be arranged for individuals, families, and groups according to their pickup location, destination, luggage, passenger count, and preferred travel schedule."
},
{
"name": "Shirdi Airport to Pune Taxi",
"description": "Shirdi Airport to Pune Taxi offers a convenient travel option for passengers heading from the Shirdi Airport area to Pune. Customers can select a suitable vehicle based on their group size, luggage requirements, destination, and planned departure time."
},
{
"name": "Pune Airport pickup from Shirdi",
"description": "Pune Airport pickup from Shirdi provides scheduled private transportation for passengers traveling from Shirdi to catch a flight at Pune Airport. Pickup timing can be coordinated according to the flight schedule, travel requirements, passenger count, and luggage."
},
{
"name": "Pune Airport drop from Shirdi",
"description": "Pune Airport drop from Shirdi offers direct cab transportation for travelers who need to reach Pune Airport from Shirdi. The service can be planned around the flight departure time with suitable vehicle options for individuals, families, and groups."
},
{
"name": "affordable Shirdi to Pune Airport taxi",
"description": "Affordable Shirdi to Pune Airport taxi provides a practical airport transfer option for travelers looking to manage transportation costs. Customers can select a suitable vehicle based on passenger requirements, luggage, travel schedule, and preferred one-way or return arrangement."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides Shirdi to Pune Airport cab and taxi services for individuals, families, devotees, corporate travelers, and groups. Customers can book Sedan, Ertiga, Innova, or Innova Crysta options for one-way, round-trip, and scheduled airport transfer requirements."
}
],
"tableData": [
["Shirdi to Pune Airport Cab", "Shirdi to Pune Airport Taxi"],
["Shirdi to Pune Airport cab service", "Shirdi to Pune Airport taxi service"],
["Shirdi to Pune Airport cab booking", "Shirdi to Pune Airport taxi booking"],
["Shirdi to Pune Airport taxi fare", "Shirdi to Pune Airport cab fare"],
["Shirdi to Pune Airport one way cab", "Shirdi to Pune Airport one way taxi"],
["Shirdi to Pune Airport round trip cab", "Shirdi to Pune Airport Ertiga Cab"],
["Shirdi to Pune Airport Innova Cab", "Shirdi to Pune Airport Innova Crysta Cab"],
["Shirdi to Pune Airport Sedan Cab", "Shirdi Airport to Pune Cab"],
["Shirdi Airport to Pune Taxi", "Pune Airport pickup from Shirdi"],
["Pune Airport drop from Shirdi", "affordable Shirdi to Pune Airport taxi"],
["Sai Shirdi Cabs", "Shirdi to Pune Airport Cab"]
]
,







whychoose: [  
 
    {   
 
        WhyChooseheading: "Shirdi to Pune Airport Cab for Convenient Airport Travel",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides Shirdi to Pune Airport Cab services for devotees, families, tourists, business travellers, and passengers requiring convenient airport transportation. A private cab can be arranged from Shirdi to Pune Airport according to your travel schedule, pickup location, passenger count, luggage requirements, and preferred departure time."   
 
    },   
 
    {   
 
        WhyChooseheading: "Reliable Taxi Service from Shirdi to Pune Airport",   
 
        WhyChoosedescription: "Passengers can book a private taxi from Shirdi to Pune Airport for direct intercity transportation. Sai Shirdi Cabs can coordinate the pickup according to your location in Shirdi and planned airport schedule, making it suitable for travellers who want an organized transfer without changing multiple vehicles during the journey."   
 
    },   
 
    {   
 
        WhyChooseheading: "Private Cab for Shirdi to Pune Airport Transfers",   
 
        WhyChoosedescription: "A private cab provides a practical option for individuals, families, and small groups travelling from Shirdi to Pune Airport. The journey can be planned around your preferred departure time, passenger requirements, luggage, pickup location, and flight schedule so that your airport transfer fits smoothly into your overall travel plan."   
 
    },   
 
    {   
 
        WhyChooseheading: "Airport Cab for Sai Baba Devotees and Visitors",   
 
        WhyChoosedescription: "Devotees completing their Sai Baba Darshan in Shirdi can book a cab to Pune Airport for their onward journey. After completing their pilgrimage, passengers can arrange direct transportation from their hotel or selected pickup point in Shirdi to Pune Airport based on their flight timing and travel requirements."   
 
    },   
 
    {   
 
        WhyChooseheading: "One Way Cab from Shirdi to Pune Airport",   
 
        WhyChoosedescription: "Passengers who need only airport transportation can book a one-way cab from Shirdi to Pune Airport. The service can be planned with your preferred pickup location, travel date, departure time, passenger count, luggage details, and airport destination for a straightforward intercity airport transfer."   
 
    },   
 
    {   
 
        WhyChooseheading: "Shirdi to Pune Airport Cab for Families and Groups",   
 
        WhyChoosedescription: "Families and small groups can arrange a private cab from Shirdi to Pune Airport when travelling together with luggage. Providing the passenger count and luggage information during booking helps in planning transportation according to the group's requirements and makes it easier to coordinate the journey from Shirdi to the airport."   
 
    },   
 
    {   
 
        WhyChooseheading: "Cab Booking According to Flight Schedule",   
 
        WhyChoosedescription: "Travellers can share their flight details and preferred pickup requirements while booking a Shirdi to Pune Airport Cab. Planning the journey around the flight schedule helps passengers organize their departure from Shirdi and account for the planned travel time, luggage, passenger requirements, and airport arrival needs."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book Shirdi to Pune Airport Cab with Sai Shirdi Cabs",   
 
        WhyChoosedescription: "To book a Shirdi to Pune Airport Cab, provide Sai Shirdi Cabs with your pickup location, travel date, preferred departure time, flight details, passenger count, luggage requirements, and any additional travel needs. Complete journey information helps in arranging suitable airport transportation according to your planned schedule."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I book a Shirdi to Pune Airport Cab?", 
 
answer: "Yes, Sai Shirdi Cabs provides private cab services from Shirdi to Pune Airport for devotees, families, tourists, business travellers, and passengers requiring airport transportation." 
 
}, 
 
{ 
 
question: "Can I book a taxi from Shirdi to Pune Airport for my flight?", 
 
answer: "Yes, you can book a private taxi from Shirdi to Pune Airport according to your flight schedule, preferred pickup time, passenger count, luggage requirements, and travel plans." 
 
}, 
 
{ 
 
question: "Is one-way cab service available from Shirdi to Pune Airport?", 
 
answer: "Yes, one-way cab service can be arranged from Shirdi to Pune Airport according to your pickup location, travel date, departure time, and airport transfer requirements." 
 
}, 
 
{ 
 
question: "Can I book a Shirdi to Pune Airport cab after Sai Baba Darshan?", 
 
answer: "Yes, devotees can arrange a cab from their hotel or selected pickup location in Shirdi to Pune Airport after completing Sai Baba Darshan and other planned activities." 
 
}, 
 
{ 
 
question: "Can families book a Shirdi to Pune Airport taxi?", 
 
answer: "Yes, families can book a private taxi from Shirdi to Pune Airport and provide their passenger count and luggage details to help plan the transportation arrangement." 
 
}, 
 
{ 
 
question: "Can I travel with luggage in a Shirdi to Pune Airport Cab?", 
 
answer: "Yes, passengers can travel with luggage, and you should provide the luggage details along with the passenger count while booking so the transportation can be planned according to your requirements." 
 
}, 
 
{ 
 
question: "Can I book a cab from my hotel in Shirdi to Pune Airport?", 
 
answer: "Yes, pickup from your hotel or another suitable location in Shirdi can be discussed while booking the cab, subject to the travel details and service arrangement." 
 
}, 
 
{ 
 
question: "Can I book a Shirdi to Pune Airport Cab for a group?", 
 
answer: "Yes, small groups can arrange private cab transportation from Shirdi to Pune Airport based on the number of passengers, luggage requirements, travel schedule, and preferred vehicle arrangement." 
 
}, 
 
{ 
 
question: "Should I provide my flight details while booking?", 
 
answer: "Providing your flight details can help in planning the airport transfer according to your scheduled departure and preferred pickup time from Shirdi." 
 
}, 
 
{ 
 
question: "How can I book a Shirdi to Pune Airport Cab?", 
 
answer: "You can contact Sai Shirdi Cabs with your Shirdi pickup location, travel date, preferred departure time, flight details, passenger count, luggage information, and other requirements to arrange your cab booking." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Amit Deshmukh", 
 
feedback: "We booked a Shirdi to Pune Airport Cab after completing our Sai Baba Darshan. The private taxi was convenient for our family, especially because we had luggage and wanted to travel directly from Shirdi to the airport.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Priya Kulkarni", 
 
feedback: "Our family used Sai Shirdi Cabs for transportation from Shirdi to Pune Airport. We shared our flight schedule and luggage details during booking, which made it easier to organize our airport transfer and travel together.", 
 
rating: 5 
 
} 
 
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Pune Airport Cab",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-pune-airport-cab.webp",
  "description":
    "Book a Shirdi to Pune Airport Cab with Sai Shirdi Cabs for a comfortable, convenient, and reliable airport transfer from Shirdi to Pune Airport. Our cab service is suitable for airport transfers, Sai Baba Darshan, family travel, business trips, one-way journeys, and scheduled travel. Get well-maintained cars, professional drivers, affordable fares, flexible pickup locations, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-pune-airport-cab"
  }
};







    return (
        <div>


<Helmet>
  <title>Shirdi to Pune Airport Cab | Shirdi to Pune Airport Taxi | +91 7776814559</title>

  <meta
    name="description"
    content="Book a Shirdi to Pune Airport Cab with Sai Shirdi Cabs for a comfortable and reliable airport transfer. Get professional drivers, well-maintained cars, affordable fares and easy booking for one-way journeys from Shirdi to Pune Airport."
  />

  <meta
    name="keywords"
    content="Shirdi to Pune Airport Cab, Shirdi to Pune Airport Taxi, Shirdi to Pune Airport cab service, Shirdi to Pune Airport taxi service, Shirdi to Pune Airport cab booking, Shirdi to Pune Airport taxi booking, Shirdi to Pune Airport taxi fare, Shirdi to Pune Airport cab fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditopuneairportcab;